
/**
 * Représente les constantes
 */
export class Constantes {

    // Constantes CATEGORIE
    public static CATEGORIE_POINT_RELAIS: string = 'REL';
    public static CATEGORIE_TRANSPORTEUR: string = 'TRN';
    public static CATEGORIE_TRANSPORTEUR_PARTENAIRE: string = 'TRN_PTN';
    public static CATEGORIE_AUTRE: string = 'AUT';
}

/**
 * Réprésente l'énumération de l'état du document
 */
export enum EtatDocumentEnum {
    Aucun = 0,
    EnCoursDeValidation = 1,
    Rejete = 2,
    Valide = 3
}

/**
 * Réprésente l'énumération du type de document
 */
export enum TypeDocumentEnum {
    Inconnu = 0,
    PhotoPR = 1
}
